import {
  createInventoryItem as publicCreateInventoryItem,
  bulkCreateInventoryItems as publicBulkCreateInventoryItems,
  getInventoryItem as publicGetInventoryItem,
  updateInventoryItem as publicUpdateInventoryItem,
  bulkUpdateInventoryItems as publicBulkUpdateInventoryItems,
  bulkUpsertInventoryItems as publicBulkUpsertInventoryItems,
  bulkUpdateInventoryItemsByFilter as publicBulkUpdateInventoryItemsByFilter,
  deleteInventoryItem as publicDeleteInventoryItem,
  bulkDeleteInventoryItems as publicBulkDeleteInventoryItems,
  bulkDeleteInventoryItemsByFilter as publicBulkDeleteInventoryItemsByFilter,
  queryInventoryItems as publicQueryInventoryItems,
  typedQueryInventoryItems as publicTypedQueryInventoryItems,
  searchInventoryItems as publicSearchInventoryItems,
  bulkDecrementInventoryItems as publicBulkDecrementInventoryItems,
  bulkIncrementInventoryItems as publicBulkIncrementInventoryItems,
  bulkDecrementInventoryItemsByVariantAndLocation as publicBulkDecrementInventoryItemsByVariantAndLocation,
  bulkIncrementInventoryItemsByVariantAndLocation as publicBulkIncrementInventoryItemsByVariantAndLocation,
  bulkSetOrAdjustInventoryItemsByFilter as publicBulkSetOrAdjustInventoryItemsByFilter,
  bulkAdjustInventoryItemsByFilter as publicBulkAdjustInventoryItemsByFilter,
  bulkCreateInventoryItemsByVariantFilter as publicBulkCreateInventoryItemsByVariantFilter,
} from './stores-catalog-v3-inventory-item-inventory-items-v-3.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  InventoryItemQuery,
  InventoryItemsQueryBuilder,
  typedQueryInventoryItems as universalTypedQueryInventoryItems,
} from './stores-catalog-v3-inventory-item-inventory-items-v-3.universal.js';
import { onInventoryItemCreated as publicOnInventoryItemCreated } from './stores-catalog-v3-inventory-item-inventory-items-v-3.public.js';
import { onInventoryItemDeleted as publicOnInventoryItemDeleted } from './stores-catalog-v3-inventory-item-inventory-items-v-3.public.js';
import { onInventoryItemStockStatusUpdated as publicOnInventoryItemStockStatusUpdated } from './stores-catalog-v3-inventory-item-inventory-items-v-3.public.js';
import { onInventoryItemUpdated as publicOnInventoryItemUpdated } from './stores-catalog-v3-inventory-item-inventory-items-v-3.public.js';
import { onInventoryItemUpdatedWithReason as publicOnInventoryItemUpdatedWithReason } from './stores-catalog-v3-inventory-item-inventory-items-v-3.public.js';

function customQueryInventoryItems(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryInventoryItems(httpClient)(),
    typedQueryFunction: (query: InventoryItemQuery) =>
      publicTypedQueryInventoryItems(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): InventoryItemsQueryBuilder;
  function overloadedQuery(
    query: InventoryItemQuery
  ): ReturnType<typeof universalTypedQueryInventoryItems>;
  function overloadedQuery(query?: InventoryItemQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createInventoryItem: MaybeContext<
  BuildRESTFunction<typeof publicCreateInventoryItem> &
    typeof publicCreateInventoryItem
> = /*#__PURE__*/ createRESTModule(publicCreateInventoryItem);
export const bulkCreateInventoryItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateInventoryItems> &
    typeof publicBulkCreateInventoryItems
> = /*#__PURE__*/ createRESTModule(publicBulkCreateInventoryItems);
export const getInventoryItem: MaybeContext<
  BuildRESTFunction<typeof publicGetInventoryItem> &
    typeof publicGetInventoryItem
> = /*#__PURE__*/ createRESTModule(publicGetInventoryItem);
export const updateInventoryItem: MaybeContext<
  BuildRESTFunction<typeof publicUpdateInventoryItem> &
    typeof publicUpdateInventoryItem
> = /*#__PURE__*/ createRESTModule(publicUpdateInventoryItem);
export const bulkUpdateInventoryItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateInventoryItems> &
    typeof publicBulkUpdateInventoryItems
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateInventoryItems);
/** @internal */
export const bulkUpsertInventoryItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpsertInventoryItems> &
    typeof publicBulkUpsertInventoryItems
> = /*#__PURE__*/ createRESTModule(publicBulkUpsertInventoryItems);
export const bulkUpdateInventoryItemsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateInventoryItemsByFilter> &
    typeof publicBulkUpdateInventoryItemsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateInventoryItemsByFilter);
export const deleteInventoryItem: MaybeContext<
  BuildRESTFunction<typeof publicDeleteInventoryItem> &
    typeof publicDeleteInventoryItem
> = /*#__PURE__*/ createRESTModule(publicDeleteInventoryItem);
export const bulkDeleteInventoryItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteInventoryItems> &
    typeof publicBulkDeleteInventoryItems
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteInventoryItems);
/** @internal */
export const bulkDeleteInventoryItemsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteInventoryItemsByFilter> &
    typeof publicBulkDeleteInventoryItemsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteInventoryItemsByFilter);
export const searchInventoryItems: MaybeContext<
  BuildRESTFunction<typeof publicSearchInventoryItems> &
    typeof publicSearchInventoryItems
> = /*#__PURE__*/ createRESTModule(publicSearchInventoryItems);
export const bulkDecrementInventoryItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkDecrementInventoryItems> &
    typeof publicBulkDecrementInventoryItems
> = /*#__PURE__*/ createRESTModule(publicBulkDecrementInventoryItems);
export const bulkIncrementInventoryItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkIncrementInventoryItems> &
    typeof publicBulkIncrementInventoryItems
> = /*#__PURE__*/ createRESTModule(publicBulkIncrementInventoryItems);
export const bulkDecrementInventoryItemsByVariantAndLocation: MaybeContext<
  BuildRESTFunction<
    typeof publicBulkDecrementInventoryItemsByVariantAndLocation
  > &
    typeof publicBulkDecrementInventoryItemsByVariantAndLocation
> = /*#__PURE__*/ createRESTModule(
  publicBulkDecrementInventoryItemsByVariantAndLocation
);
export const bulkIncrementInventoryItemsByVariantAndLocation: MaybeContext<
  BuildRESTFunction<
    typeof publicBulkIncrementInventoryItemsByVariantAndLocation
  > &
    typeof publicBulkIncrementInventoryItemsByVariantAndLocation
> = /*#__PURE__*/ createRESTModule(
  publicBulkIncrementInventoryItemsByVariantAndLocation
);
/** @internal */
export const bulkSetOrAdjustInventoryItemsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkSetOrAdjustInventoryItemsByFilter> &
    typeof publicBulkSetOrAdjustInventoryItemsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkSetOrAdjustInventoryItemsByFilter);
/** @internal */
export const bulkAdjustInventoryItemsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkAdjustInventoryItemsByFilter> &
    typeof publicBulkAdjustInventoryItemsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkAdjustInventoryItemsByFilter);
/** @internal */
export const bulkCreateInventoryItemsByVariantFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateInventoryItemsByVariantFilter> &
    typeof publicBulkCreateInventoryItemsByVariantFilter
> = /*#__PURE__*/ createRESTModule(
  publicBulkCreateInventoryItemsByVariantFilter
);
export const queryInventoryItems: MaybeContext<
  BuildRESTFunction<typeof customQueryInventoryItems> &
    typeof customQueryInventoryItems
> = /*#__PURE__*/ createRESTModule(customQueryInventoryItems);
/** */
export const onInventoryItemCreated: BuildEventDefinition<
  typeof publicOnInventoryItemCreated
> &
  typeof publicOnInventoryItemCreated = createEventModule(
  publicOnInventoryItemCreated
);
/** */
export const onInventoryItemDeleted: BuildEventDefinition<
  typeof publicOnInventoryItemDeleted
> &
  typeof publicOnInventoryItemDeleted = createEventModule(
  publicOnInventoryItemDeleted
);
/**
 * Triggered when an inventory item's stock is updated.
 */
export const onInventoryItemStockStatusUpdated: BuildEventDefinition<
  typeof publicOnInventoryItemStockStatusUpdated
> &
  typeof publicOnInventoryItemStockStatusUpdated = createEventModule(
  publicOnInventoryItemStockStatusUpdated
);
/** */
export const onInventoryItemUpdated: BuildEventDefinition<
  typeof publicOnInventoryItemUpdated
> &
  typeof publicOnInventoryItemUpdated = createEventModule(
  publicOnInventoryItemUpdated
);
/**
 * Triggered when an inventory item is updated.
 */
export const onInventoryItemUpdatedWithReason: BuildEventDefinition<
  typeof publicOnInventoryItemUpdatedWithReason
> &
  typeof publicOnInventoryItemUpdatedWithReason = createEventModule(
  publicOnInventoryItemUpdatedWithReason
);

export {
  AvailabilityStatus,
  EventType,
  ReasonType,
  Mode,
  SortOrder,
  SortType,
  SortDirection,
  MissingValues,
  ScalarType,
  NestedAggregationType,
  Interval,
  AggregationType,
  WebhookIdentityType,
} from './stores-catalog-v3-inventory-item-inventory-items-v-3.universal.js';
export {
  InventoryItem,
  InventoryItemTrackingMethodOneOf,
  PreorderInfo,
  Product,
  Brand,
  ExtendedFields,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  BulkInventoryItemAction,
  CreateInventoryItemRequest,
  CreateInventoryItemResponse,
  BulkCreateInventoryItemsRequest,
  BulkCreateInventoryItemsResponse,
  V3BulkInventoryItemResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  GetInventoryItemRequest,
  GetInventoryItemResponse,
  UpdateInventoryItemRequest,
  UpdateInventoryItemResponse,
  InventoryItemStockStatusUpdatedEvent,
  InventoryItemUpdatedWithReason,
  BulkUpdateInventoryItemsRequest,
  MaskedInventoryItem,
  BulkUpdateInventoryItemsResponse,
  BulkUpsertInventoryItemsRequest,
  BulkUpsertInventoryItemsResponse,
  BulkUpsertInventoryItemResult,
  BulkUpdateInventoryItemsByFilterRequest,
  SearchDetails,
  BulkUpdateInventoryItemsByFilterResponse,
  DeleteInventoryItemRequest,
  DeleteInventoryItemResponse,
  BulkDeleteInventoryItemsRequest,
  BulkDeleteInventoryItemsResponse,
  BulkInventoryItemResult,
  BulkDeleteInventoryItemsByFilterRequest,
  BulkDeleteInventoryItemsByFilterResponse,
  QueryInventoryItemsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryInventoryItemsResponse,
  PlatformPagingMetadataV2,
  CommonCursors,
  SearchInventoryItemsRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  IncludeMissingValuesOptions,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  RangeAggregation,
  ScalarAggregation,
  DateHistogramAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  GroupByAggregation,
  GroupByAggregationKindOneOf,
  SearchInventoryItemsResponse,
  CursorPagingMetadata,
  Cursors,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  SearchInventoryItemsWithOffsetRequest,
  OffsetSearch,
  OffsetSearchPagingMethodOneOf,
  SearchInventoryItemsWithOffsetResponse,
  PagingMetadata,
  BulkDecrementInventoryItemsRequest,
  DecrementDataById,
  BulkDecrementInventoryItemsResponse,
  BulkIncrementInventoryItemsRequest,
  IncrementDataById,
  BulkIncrementInventoryItemsResponse,
  BulkDecrementInventoryItemsByVariantAndLocationRequest,
  DecrementDataByVariantAndLocation,
  BulkDecrementInventoryItemsByVariantAndLocationResponse,
  BulkIncrementInventoryItemsByVariantAndLocationRequest,
  IncrementDataByVariantAndLocation,
  BulkIncrementInventoryItemsByVariantAndLocationResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  RecloneSiteRequest,
  RecloneSiteResponse,
  BulkSetOrAdjustInventoryItemsByFilterRequest,
  AdjustInventoryAction,
  AdjustInventoryActionActionOneOf,
  BulkSetOrAdjustInventoryItemsByFilterResponse,
  BulkAdjustInventoryItemsByFilterRequest,
  BulkAdjustInventoryItemsByFilterResponse,
  BulkCreateInventoryItemsByVariantFilterRequest,
  InventoryCreationData,
  BulkCreateInventoryItemsByVariantFilterResponse,
  CatalogRollbackRequested,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  InventoryItemCreatedEnvelope,
  InventoryItemDeletedEnvelope,
  InventoryItemStockStatusUpdatedEnvelope,
  InventoryItemUpdatedEnvelope,
  InventoryItemUpdatedWithReasonEnvelope,
  BulkCreateInventoryItemsOptions,
  UpdateInventoryItem,
  UpdateInventoryItemOptions,
  BulkUpdateInventoryItemsOptions,
  BulkUpsertInventoryItemsOptions,
  BulkUpdateInventoryItemsByFilterOptions,
  BulkDeleteInventoryItemsByFilterOptions,
  InventoryItemsQueryResult,
  InventoryItemsQueryBuilder,
  InventoryItemQuerySpec,
  InventoryItemSearchSpec,
  BulkDecrementInventoryItemsOptions,
  BulkIncrementInventoryItemsOptions,
  BulkDecrementInventoryItemsByVariantAndLocationOptions,
  BulkIncrementInventoryItemsByVariantAndLocationOptions,
  BulkSetOrAdjustInventoryItemsByFilterOptions,
  BulkAdjustInventoryItemsByFilterOptions,
  BulkCreateInventoryItemsByVariantFilterOptions,
} from './stores-catalog-v3-inventory-item-inventory-items-v-3.universal.js';
export { utils } from './stores-catalog-v3-inventory-item-inventory-items-v-3.universal.js';
export {
  AvailabilityStatusWithLiterals,
  EventTypeWithLiterals,
  ReasonTypeWithLiterals,
  ModeWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  MissingValuesWithLiterals,
  ScalarTypeWithLiterals,
  NestedAggregationTypeWithLiterals,
  IntervalWithLiterals,
  AggregationTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateInventoryItemApplicationErrors,
  CreateInventoryItemValidationErrors,
  BulkCreateInventoryItemsApplicationErrors,
  BulkCreateInventoryItemsValidationErrors,
  UpdateInventoryItemApplicationErrors,
  BulkUpdateInventoryItemsApplicationErrors,
  BulkUpsertInventoryItemsApplicationErrors,
  BulkUpdateInventoryItemsByFilterApplicationErrors,
  BulkDecrementInventoryItemsApplicationErrors,
  BulkIncrementInventoryItemsApplicationErrors,
  BulkDecrementInventoryItemsByVariantAndLocationApplicationErrors,
  BulkIncrementInventoryItemsByVariantAndLocationApplicationErrors,
  BulkSetOrAdjustInventoryItemsByFilterApplicationErrors,
  BulkAdjustInventoryItemsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  InventoryItemQuery,
  CommonSearchWithEntityContext,
  InventoryItemSearch,
} from './stores-catalog-v3-inventory-item-inventory-items-v-3.universal.js';
